import React, { useContext } from 'react';
import { GlobalContext } from '../../../context/GlobalContext';
import { changeFontSize } from '../../../utils/functions';

import './FontSizeSettings.scss';

const FontSizeSettings = () => {
    const { fontSize } = useContext(GlobalContext);

    return (
        <div className="a-font-settings">
            <div className="a-font-settings__legend">
                <i className="a-font-size__top__small icon-font" />
                <p>{fontSize.get}%</p>
                <i className="a-font-size__top__large icon-font" />
            </div>
            <div className="a-font-settings__actions">
                <div
                    role="button"
                    tabIndex={-1}
                    onClick={() => changeFontSize('-', fontSize)}
                    onKeyDown={(e) =>
                        e.code === 'Enter' && changeFontSize('-', fontSize)
                    }
                    aria-label="Botón para disminuir letra"
                >
                    Disminuir
                </div>
                <div
                    role="button"
                    tabIndex={-1}
                    onClick={() => changeFontSize('+', fontSize)}
                    onKeyDown={(e) =>
                        e.code === 'Enter' && changeFontSize('+', fontSize)
                    }
                    aria-label="Botón para aumentar letra"
                >
                    Aumentar
                </div>
            </div>
        </div>
    );
};

export default FontSizeSettings;
